import React, { createContext, useState, useEffect } from "react";

export const UserInteractionContext = createContext({
  userHasInteracted: false,
  setUserHasInteracted: () => {},
});

export const UserInteractionProvider = ({ children }) => {
  const [userHasInteracted, setUserHasInteracted] = useState(false);

  useEffect(() => {
    const handleFirstInteraction = () => {
      setUserHasInteracted(true);
      // après la première interaction, plus besoin d’écouter
      window.removeEventListener("click", handleFirstInteraction);
      window.removeEventListener("keydown", handleFirstInteraction);
    };

    window.addEventListener("click", handleFirstInteraction, { once: true });
    window.addEventListener("keydown", handleFirstInteraction, { once: true });

    return () => {
      window.removeEventListener("click", handleFirstInteraction);
      window.removeEventListener("keydown", handleFirstInteraction);
    };
  }, []);

  return (
    <UserInteractionContext.Provider value={{ userHasInteracted, setUserHasInteracted }}>
      {children}
    </UserInteractionContext.Provider>
  );
};
